/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Court
 */
export interface Court {
    /**
     * 
     * @type {string}
     * @memberof Court
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Court
     */
    venueId?: string;
    /**
     * 
     * @type {string}
     * @memberof Court
     */
    name?: string;
}

/**
 * Check if a given object implements the Court interface.
 */
export function instanceOfCourt(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CourtFromJSON(json: any): Court {
    return CourtFromJSONTyped(json, false);
}

export function CourtFromJSONTyped(json: any, ignoreDiscriminator: boolean): Court {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'venueId': !exists(json, 'venueId') ? undefined : json['venueId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function CourtToJSON(value?: Court | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'venueId': value.venueId,
        'name': value.name,
    };
}

